import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { Userpilot } from "userpilot";

const IdentifyUser = () => {
  const { user } = useAuthenticator((context) => [context.user]);
  const posthog = usePostHog();

  useEffect(() => {
    if (posthog && user) {
      const userProperties = user.signInDetails?.loginId
        ? { email: user.signInDetails?.loginId }
        : undefined;

      posthog.identify(user.userId, userProperties);

      Userpilot.identify(user.userId, {
        email: user.signInDetails?.loginId,
      });
    }
  }, [posthog, user]);

  return null;
};

export default IdentifyUser;
